import axios from "axios";
import { API_URL } from "../../../utils/constants";
import { toast } from "react-toastify";

export const getAzureActivityLogsApi = async (param, provider) => {
  try {
    param.params.type = 2;
    const token = localStorage.getItem('api_token');
    const endpoint = provider === "gcp" ? "gcp/console-logs" : "get-azure-activity-logs";
    const response = await axios({
      method: "GET",
      url: `${API_URL}${endpoint}`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": token ? `Bearer ${token}` : "",
      },
      data: param.params,
    });
    return response;
  } catch (e) {
    return [];
  }
};
